import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog.tsx';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export type UseLockedPackageConfirmationModal = {
  onUseAsTargeting?: () => void;
  onUseAsTemplate?: () => void;
  onCancel?: () => void;
};

const Content = () => {
  const { t } = useTranslation();

  return (
    <DialogContent dividers>
      <Typography>
        {t(
          'This package is locked for edition. You can use it either as a template (saving your changes in a new package) or as shared targeting (without your changes).'
        )}
      </Typography>
    </DialogContent>
  );
};

export const useLockedPackageConfirmationModal = () => {
  const { t } = useTranslation();
  const confirmationDialog = useConfirmationDialog();

  const showLockedPackageConfirmation = useCallback(
    ({ onUseAsTargeting, onCancel, onUseAsTemplate }: UseLockedPackageConfirmationModal) => {
      confirmationDialog.open({
        content: <Content />,
        customContent: true,
        onCancel: () => {
          confirmationDialog.close();
          onCancel?.();
        },
        confirmationButtonColor: 'primary',
        confirmationLabel: t('Use as Targeting'),
        onConfirmed: () => {
          onUseAsTargeting?.();
          confirmationDialog.close();
        },
        extraBtnLabel: t('Use as Template'),
        onExtraAction: () => {
          onUseAsTemplate?.();
          confirmationDialog.close();
        },
        showExtraBtn: true,
        title: t('Confirmation'),
      });
    },
    [confirmationDialog, t]
  );

  return { showLockedPackageConfirmation };
};
